import type { TextProps } from './text.types';
import { cn } from '@/utils/helper';
import v1 from './text-v1.module.css';
import v2 from './text-v2.module.css';

export default function Text(props: TextProps) {
  return <div className={cn(v1.Text, v2.Text)}>{props.content}</div>;
}
